import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import CalculateIcon from "@mui/icons-material/Calculate";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import PaperComponent from "../../components/PaperComponent";
import {
  obterImpostos,
  obterImpostosPorCampoDeBusca,
  cadastrarImpostos,
  atualizarImpostos,
  excluirImpostos,
} from "../../services/api-esocial.service";
import { handleErrorResponse } from "../../utils/error.util";
import { Context } from "src/config/AuthContext";
import ImpostosForm from "src/forms/ImpostosForm";
import { Poll } from "@mui/icons-material";

const Impostos = () => {
  const navigate = useNavigate();

  const { handleLogout } = useContext(Context);

  const [loading, setLoading] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [msg, setMsg] = useState("");

  const [idGrupoEconomico, setIdGrupoEconomico] = useState(null);
  const [idEmpresa, setIdEmpresa] = useState(null);
  const [impostosData, setImpostosData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openDialogExclusao, setOpenDialogExclusao] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);

  const columns = [
    { id: "idImposto", label: "ID", field: "idImposto" },
    { id: "referencia", label: "Referência", field: "referencia_cellVal" },
    {
      id: "terceiros",
      label: "Terceiros",
      field: "terceiros_cellVal",
      type: "porcentagem",
    },
    { id: "rat", label: "Rat", field: "rat_cellVal", type: "porcentagem" },
    {
      id: "inss",
      label: "Parte Emp.",
      field: "inss_cellVal",
      type: "porcentagem",
    },
  ];

  const handleOpenModal = async (rowData) => {
    rowData.idImposto !== undefined
      ? setEditRowData(rowData)
      : setEditRowData({});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveChanges = async (data) => {
    setLoading(true);

    if (!editRowData.idImposto) {
      await cadastrarImpostos(idEmpresa, { impostos: data.impostos })
        .then(async (response) => {
          setMsg(response.mensagem);
          await getImpostos(idEmpresa);
          handleCloseModal();
          handleOpenSnackbarSucesso();
        })
        .catch((err) =>
          handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
        );
    } else {
      await atualizarImpostos(idEmpresa, editRowData.idImposto, {
        impostos: data.impostos,
      })
        .then(async (response) => {
          setMsg(response.mensagem);
          await getImpostos(idEmpresa);
          handleCloseModal();
          handleOpenSnackbarSucesso();
        })
        .catch((err) =>
          handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
        );
    }

    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    await excluirImpostos(idEmpresa, editRowData.idImposto)
      .then(async (response) => {
        setMsg(response.mensagem);
        await getImpostos(idEmpresa);
        handleCloseDialogExclusao();
        handleOpenSnackbarSucesso();
      })
      .catch((err) =>
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
      );
    setLoading(false);
  };

  const getImpostos = async (idEmpresa) => {
    try {
      const response = await obterImpostos(idEmpresa);
      setImpostosData(addTableCellValues(response.impostos));
    } catch (err) {
      handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
    }
  };

  const addTableCellValues = (impostos) => {
    impostos.forEach((imposto) => {
      imposto.referencia_cellVal =
        imposto.referencia.split("-")[1] +
        "/" +
        imposto.referencia.split("-")[0];
      imposto.terceiros_cellVal = imposto.terceiros;
      imposto.rat_cellVal = imposto.rat;
      imposto.inss_cellVal = imposto.inss;
    });
    return impostos;
  };

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (!reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  const handleDebouncerChange = async (event) => {
    setLoading(true);
    try {
      const response = await obterImpostosPorCampoDeBusca(
        idEmpresa,
        event.target.value
      );
      setImpostosData(addTableCellValues(response.impostos));
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setImpostosData([]);
      } else {
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (idGrupoEconomico !== null && idEmpresa !== null) {
        setLoading(true);
        await getImpostos(idEmpresa);
        setLoading(false);
      } else {
        setLoading(true);
        setImpostosData([]);
        setLoading(false);
      }
    };

    fetchData();
  }, [idEmpresa]);

  const handleGrupoECnpjChange = async (ids) => {
    setIdGrupoEconomico(ids.GE);
    setIdEmpresa(ids.CNPJ);
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={<Poll fontSize="30px" />}
        headerTitle={"Impostos"}
        handleDebounceChange={handleDebouncerChange}
        handleOpenModal={handleOpenModal}
        modalButtonLabel={"Novo"}
        AutoCompleteGrupoECnpj
        handleGrupoECnpjChange={handleGrupoECnpjChange}
      />

      <TabelaDinamica
        data={impostosData}
        columns={columns}
        loading={loading}
        orderColumn={"idImposto"}
        onEditButtonClick={handleOpenModal}
        onDeleteButtonClick={handleClickOpenDialogExclusao}
      />

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "140%", // Defina a largura desejada
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle className={styles.popupHeader}>
          <div className={styles.linhaTituloPopup} />
          <div className={styles.tituloPopupContainer}>
            <CalculateIcon className={styles.iconeTituloPopup} />
            <h1 className={styles.tituloPopup}>
              {editRowData.idUsuario
                ? "Edição de Imposto"
                : "Cadastro de Imposto"}
            </h1>
          </div>
        </DialogTitle>
        <ImpostosForm
          impostosValues={Object.assign({}, editRowData)}
          onSubmit={handleSaveChanges}
          onClose={handleCloseModal}
          className={styles.popupContent}
        ></ImpostosForm>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir permanentemente o imposto{" "}
            {editRowData.referencia_cellVal}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default Impostos;
